import { Box } from "@mui/material";
import { ReactNode } from "react";

interface ModalWrapperProps {
  children: ReactNode;
  onClose?: () => void;
}

export const ModalWrapper = ({ children, onClose }: ModalWrapperProps) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1300,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={onClose}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "24px",
          minWidth: "300px",
          maxWidth: "90%",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
